import {combineReducers} from 'redux';
import lodash from "lodash";
import * as ACTION from './constants';
import {CREATE_BAG_SIZE} from '../CreateBagSize/constants';
import * as BAG_SIZE_ACTION from '../constants';

export const loading = (state = false, action) => {
    switch (action.type) {
        case CREATE_BAG_SIZE.REQUEST:
	    case BAG_SIZE_ACTION.UPDATE_BAG_SIZE.REQUEST:
            return true;
        case CREATE_BAG_SIZE.SUCCESS:
        case CREATE_BAG_SIZE.FAILED:
	    case BAG_SIZE_ACTION.UPDATE_BAG_SIZE.SUCCESS:
	    case BAG_SIZE_ACTION.UPDATE_BAG_SIZE.FAILED:
        case ACTION.CLEAR_STATE:
            return false;
        default:
            return state;
    }
};

export const errors = (state = {}, action) => {
    let {type} = action;

    switch (type) {
        case CREATE_BAG_SIZE.REQUEST:
        case CREATE_BAG_SIZE.SUCCESS:
	    case BAG_SIZE_ACTION.UPDATE_BAG_SIZE.REQUEST:
	    case BAG_SIZE_ACTION.UPDATE_BAG_SIZE.SUCCESS:
        case ACTION.CLEAR_STATE:
            return {};
        case CREATE_BAG_SIZE.FAILED:
	    case BAG_SIZE_ACTION.UPDATE_BAG_SIZE.FAILED:
            return {...action.payload};
        case ACTION.RESET_ERROR:
            return {...state, data: lodash.omit(state.data, action.payload.params)};
        default:
            return state;
    }
};

export default combineReducers({
    loading,
    errors
});
